import { Injectable, OnDestroy } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MediaService {
  orientation: Observable<'portrait'|'landscape'> = fromEvent(window.matchMedia("(orientation: portrait)"), 'change').pipe(
    map((e: MediaQueryListEvent): 'portrait'|'landscape'  => e.matches ? 'portrait' : 'landscape'),
    share()
  );
  get currentOrientation(){
    return window.matchMedia("(orientation: portrait)").matches ? 'portrait' : 'landscape';
  }
  constructor() {}

}